"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseDOM = void 0;
/**
 * Verifies if an application can use DOM.
 */
function canUseDOM() {
    return (typeof window !== 'undefined' &&
        !!(window.document &&
            // eslint-disable-next-line deprecation/deprecation
            window.document.createElement));
}
exports.canUseDOM = canUseDOM;
//# sourceMappingURL=canUseDOM.js.map